import { Grid, Stack, Typography } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getChallanDetails } from '../../server/api/inspectionBooking';
import { useDevice } from '../../hooks/useResponsive';
import ChallanReceiptContent from './challanReceiptContent';
import img from '../../images/success-page.png';

function ChallanSuccessPage() {
  const { isMobile } = useDevice();
  const params = useParams();
  const dispatch = useDispatch();
  const printRef = useRef(null);

  const { challanSingleViewDetails, loading } = useSelector((state) => ({
    challanSingleViewDetails: state.Inspection.challanSingleViewDetails,
    loading: state.Inspection.loading,
  }));

  // console.log(challanSingleViewDetails);

  useEffect(() => {
    const credentials = {
      challanId: params?.id,
      dispatch,
    };
    dispatch(getChallanDetails(credentials));
  }, [dispatch, params?.id]);

  return (
    <>
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        spacing={2}
        py={2}
        sx={{ textAlign: 'center', backgroundColor: '#121212', mt: !isMobile && '120px' }}
        minHeight={200}
      >
        <img
          src={img}
          alt="success"
          style={{
            height: isMobile ? 80 : '120px',
            width: isMobile ? 80 : '120px',
          }}
        />
        <Stack pt={2}>
          <Typography variant={isMobile ? 'h5' : 'h3'} color="GrayText">
            Payment Done Successfully!
          </Typography>
          {/* <Typography color="gray" variant={isMobile ? 'subtitle2' : 'subtitle1'}>
            Your application submitted successfully
          </Typography> */}
        </Stack>
      </Stack>
      <Grid container justifyContent="center" sx={{ backgroundColor: '#121212', mb: !isMobile && 15 }}>
        <Grid item lg={7} md={10} sm={12} xs={12} sx={{ px: 0 }}>
          <Grid container justifyContent="center" sx={{}}>
            <Grid item xs={12} sx={{ px: 0, mb: isMobile && 15 }}>
              <ChallanReceiptContent ref={printRef} challanData={challanSingleViewDetails} loading={loading} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default ChallanSuccessPage;
